import { AreaWorkstation } from '@/types/area'
import styles from './WorkstationItem.module.scss'
import clsx from 'clsx'

export const InactiveWorkstationItem = ({ workstation }: { workstation: AreaWorkstation }) => {
    return (
        <div className={styles.workstationItem}>
            <div className={styles.header}>
                <div className={styles.titleContainer}>
                    <span className={clsx(styles.title, styles.titleInactive)}>{workstation.number}</span>
                </div>
                <span className={styles.shift}>Workstation not active</span>
            </div>

            <div className={styles.routesContainer}>
                <div className={styles.route}>
                    <div className={styles.skeleton} />
                    <div className={styles.skeletonLong} />
                </div>
                <div className={styles.route}>
                    <div className={styles.skeleton} />
                    <div className={styles.skeletonLong} />
                </div>
                <div className={styles.route}>
                    <div className={styles.skeleton} />
                    <div className={styles.skeletonLong} />
                </div>
            </div>
        </div>
    )
}
